module.exports = __webpack_public_path__ + "static/media/education.9da408ca.jpg";